import React from 'react';
import Image from '../../UI/Image/Image';

const NextArrow = (props: any) => {
  const { className, onClick } = props;
  const disabledClass = className.indexOf("slick-disabled") > -1 ? " hide-smooth" : "";
  return (
    <button onClick={onClick} className={`slide-button slide-button_next${disabledClass}`}>
      <svg version="1.1" x="0px" y="0px" viewBox="0 0 15 26">
        <polygon className="st0" points="1.6,26 0,23.9 11.2,13.1 0,2.1 1.6,0 15,13.1 " fill="#ffffff" />
      </svg>
    </button>
  );
};

export default NextArrow;
